/*@ngInject*/
const SaveAttachmentRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    function generateQueryString(payload) {
        let result = Object.keys(payload).map(function (key) {
            return key + '=' + encodeURIComponent(payload[key]) + '&';
        }).join();
        result = _.replace(result, /,/g, '');
        let lastIndex = _.lastIndexOf(result, '&');
        result = result.substr(0, lastIndex);
        return result;
    }

    this.saveAttachment = function (data, file) {
        let url = '/rest/UnderwritingAttachment/upload?' + generateQueryString(data),
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                }
            };

        formData.append('file', file);

        return this.post(url, formData, config);
    };
};

angular.module('umCore')
    .service('saveAttachmentRepository', SaveAttachmentRepository);
